module.exports = __webpack_public_path__ + "static/media/Self-Serving Bias.041f277a.jpg";